import React from 'react';
import BlogMain from '../BlogMain/BlogMain';

const Blog = () => {
    return (
        <div>
            <BlogMain />
        </div>
    );
};

export default Blog;